export const AFROLOOM_PRODUCTS = [
  {
    name: 'Loomstore',
    tag: 'Fashion',
    tagColor: 'amber',
    href: '/products/loomstore',
    title: 'Custom & ready-to-wear Afrocentric fashion',
    description:
      'Design custom pieces with our 3D configurator, order bespoke tailoring online, or shop curated ready-to-wear Afrocentric clothing, accessories, and graduation sashes.',
    highlights: [
      '3D customization for clothing, accessories, and more',
      'Ready-to-wear marketplace with secure checkout',
      'Partner network of skilled artisans and tailors',
    ],
    cta: 'Explore Loomstore',
    ctaSecondary: 'About Loomstore',
    ctaSecondaryHref: '/products/loomstore/about',
    accent: 'border-amber-200 bg-gradient-to-br from-amber-50 to-white',
    badge: 'bg-amber-100 text-amber-800',
    icon: 'L',
    iconBg: 'bg-amber-500',
  },
  {
    name: 'Kwikhelp',
    tag: 'Services',
    tagColor: 'blue',
    href: '/products/kwikhelp',
    title: 'Expert guidance when you need it most',
    description:
      'Connect with verified professionals for instant advice, one-on-one consultations, and live group events — across legal, mental health, career coaching, and more.',
    highlights: [
      'Instant sessions and scheduled consultations',
      'Verified professionals with trust & safety built in',
      'Secure payments and transparent refund policies',
    ],
    cta: 'Explore Kwikhelp',
    ctaSecondary: 'Get support',
    ctaSecondaryHref: '/products/kwikhelp/help-support',
    accent: 'border-blue-200 bg-gradient-to-br from-blue-50 to-white',
    badge: 'bg-blue-100 text-blue-800',
    icon: 'K',
    iconBg: 'bg-blue-500',
  },
];
